document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ingredient-cards-slider]').forEach(function (slider) {
      if (slider._swiperInit) return;
      slider._swiperInit = true;
  
      var sectionRoot = slider.closest('[data-ingredient-cards-root]');
      if (!sectionRoot) return;
  
      new Swiper(slider, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        centeredSlides: false,
        allowTouchMove: true,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: sectionRoot.querySelector('.ingredient-cards__pagination'),
          clickable: true
        },
        breakpoints: {
          640: { slidesPerView: 1.5, spaceBetween: 16 },
          769: { slidesPerView: 2.2, spaceBetween: 16 },
          1024: { slidesPerView: 3.2, spaceBetween: 18 },
          1280: { slidesPerView: 3, spaceBetween: 20 }
        }
      });
    });
  });
  